"use client";
import { forwardRef as e } from "react";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-progress";
//#region src/components/atoms/Progress/Progress.tsx
var r = e((e, r) => /* @__PURE__ */ t(n.Root, {
	"data-slot": "progress",
	...e,
	ref: r
}));
r.displayName = "ProgressRoot";
var i = e((e, r) => /* @__PURE__ */ t(n.Indicator, {
	"data-slot": "progress-indicator",
	...e,
	ref: r
}));
i.displayName = "ProgressIndicator";
//#endregion
export { i as ProgressIndicator, r as ProgressRoot };
